import React, { useContext } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import ProviderList from "./listProvider";
import { ContextList } from "./listContext";
import ListFilters from "./__filters";
import ListPagination from "./__pagination";
import Table from "../table";
import "./styles.css";

// Список: фильтры + тело + пагинация. Страница передаёт header/renderRow/filters
// и ApiModel — остальное делает провайдер. Тело по умолчанию таблица; страница может
// подменить его своим представлением через renderList (напр. плитка скриншотов).
export default function List({ children, ...other }) {
    return <ProviderList {...other}>
        <ListView/>
        {children}
    </ProviderList>;
}

function ListView() {
    const contextList = useContext(ContextList);
    return <div className="list">
        <ListFilters/>
        <div className="list__progress">
            {contextList.isLoad ? <LinearProgress/> : null}
        </div>
        {contextList.renderList
            ? contextList.renderList(contextList.list)
            : <Table
                header={contextList.header}
                rows={contextList.list}
                renderRow={contextList.renderRow}
                className={contextList.tableClassName}
                selectedIds={contextList.selectedIds}
            />}
        <ListPagination/>
    </div>;
}
